import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ChevronRightIcon, SproutIcon } from 'lucide-react';
import { legalLinks, navigation } from '../data/navigation';
type Crumb = {
  label: string;
  href: string;
};
export function UnderConstruction() {
  const {
    pathname
  } = useLocation();
  const crumbs = getCrumbs(pathname);
  const title = crumbs[crumbs.length - 1]?.label ?? 'Page introuvable';
  return <section className="w-full bg-cream" data-id="element-214" data-mp="d80viya7fg0f">
      <div className="mx-auto flex min-h-[70vh] max-w-7xl flex-col px-5 py-12 md:px-8 md:py-16" data-id="element-215" data-mp="d6puh6858md0">
        <nav aria-label="Fil d’Ariane" data-id="element-216" data-mp="i00schuz9sss">
          <ol className="flex flex-wrap items-center gap-1 text-sm text-ink/60" data-id="element-217" data-mp="i13iuooe1t86">
            <li data-id="element-218" data-mp="lzjax6zbtrsg">
              <Link to="/" className="hover:text-aloe-900" data-id="element-219" data-mp="m25iv7q4q9b7">
                Accueil
              </Link>
            </li>
            {crumbs.map((crumb, i) => <li key={crumb.href} className="flex items-center gap-1" data-id="element-220" data-mp="vza67avpoatl" data-mpi={i}>
                <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="3oposl5o4sh53" />
                {i === crumbs.length - 1 ? <span aria-current="page" className="text-ink" data-id="element-222" data-mp="3jpkcvhv1rqfx">
                    {crumb.label}
                  </span> : <span data-id="element-223" data-mp="3apnhkxe5jtbw">{crumb.label}</span>}
              </li>)}
          </ol>
        </nav>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex flex-1 flex-col items-start justify-center py-16" data-id="element-224" data-mp="bb1w8rr1j2kp">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-leaf/20 text-aloe-700" data-id="element-225" data-mp="2g3zf9krv5o3">
            <SproutIcon className="h-7 w-7" aria-hidden="true" data-id="element-226" data-mp="3tmox3c5c1bu3" />
          </span>
          <h1 className="mt-8 max-w-3xl font-serif text-5xl leading-[1.02] text-aloe-900 md:text-7xl" data-id="element-227" data-mp="uzua8tlcuh3i">{title}</h1>
          <p className="mt-4 font-serif text-3xl italic text-sage md:text-4xl" data-id="element-228" data-mp="q5yd1tcx0y9e">En attente de construction.</p>
          <p className="mt-6 max-w-lg text-lg text-ink/70" data-id="element-229" data-mp="1e34p1jzn10o1">
            Cette page pousse encore, comme nos aloès en Andalousie. Revenez très bientôt pour la découvrir.
          </p>
          <Link to="/" className="mt-10 inline-flex items-center gap-2 rounded-full bg-aloe-900 px-6 py-3.5 text-sm font-semibold text-cream transition-colors duration-150 ease-out hover:bg-aloe-700" data-id="element-230" data-mp="109n3xurazfvw">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-231" data-mp="vd69kitig5ad" />
            Retour à l’accueil
          </Link>
        </motion.div>
      </div>
    </section>;
}
function getCrumbs(pathname: string): Crumb[] {
  for (const item of navigation) {
    if (item.href === pathname) return [{
      label: item.label,
      href: item.href
    }];
    const child = item.children?.find(c => c.href === pathname);
    if (child) return [{
      label: item.label,
      href: item.href
    }, {
      label: child.label,
      href: child.href
    }];
  }
  const legal = legalLinks.find(l => l.href === pathname);
  return legal ? [{
    label: legal.label,
    href: legal.href
  }] : [];
}